import React from "react";
import { PlayerToPay } from "../playerToPay/PlayerToPay";
import { useSelectCircleStore } from "../../stores/StoreContext";

type props = {};

export const SelectPlayersToPay: React.FC<props> = () => {
  const selectCircleStore = useSelectCircleStore();
  return (
    <div>
      {selectCircleStore
        .adjustAndGetSelectedPlayersList()
        .map((player, index) => (
          <PlayerToPay key={player.userId} player={player} index={index} />
        ))}
    </div>
  );
};
